import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import Vue from 'vue';
import availableFilters from './availableFilters';
import { useFetchResources, props as fetchResourcesProps } from '~/composables/useFetchResources';
import Invitation from '~/models/Invitation';
import InvitationStateEnum from '~/enums/InvitationStateEnum';
import GenderEnum from '~/enums/GenderEnum';
import ModalSaveInvite from '~/components/ModalSaveInvite';
import EmptyState from '~/components/EmptyState';
import InvitationFilterCollection from '~/pages/shared/invitations/partials/InvitationFilterCollection';
export default Vue.extend({
  components: {
    ModalSaveInvite: ModalSaveInvite,
    EmptyState: EmptyState,
    InvitationFilterCollection: InvitationFilterCollection
  },
  props: _objectSpread(_objectSpread({}, fetchResourcesProps()), {}, {
    filters: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    }
  }),
  setup: function setup(props) {
    var _useFetchResources = useFetchResources(props),
      fetchResources = _useFetchResources.fetchResources,
      pagination = _useFetchResources.pagination,
      resources = _useFetchResources.resources,
      loading = _useFetchResources.loading;
    return {
      fetchResources: fetchResources,
      pagination: pagination,
      resources: resources,
      loading: loading
    };
  },
  data: function data() {
    return {
      modalUpdateInviteVisible: null,
      InvitationStateEnum: InvitationStateEnum
    };
  },
  computed: {
    enabledFilters: function enabledFilters() {
      var _this = this;
      return availableFilters.filter(function (filter) {
        return _this.filters.includes(filter.key);
      }).map(function (_ref) {
        var key = _ref.key,
          type = _ref.type;
        return {
          key: key,
          type: type
        };
      });
    }
  },
  methods: {
    getFields: function getFields() {
      return [{
        key: 'meta.gender',
        label: ''
      }, {
        key: 'email',
        label: this.$t('fields.email_address')
      }, {
        key: 'url',
        label: this.$t('fields.registration_link')
      }, {
        key: 'state',
        label: this.$t('fields.state'),
        sortable: true
      }, {
        key: 'actions',
        label: '',
        contentAlign: 'right'
      }];
    },
    onClipboardSuccess: function onClipboardSuccess() {
      this.$notify.success(this.$t('notifications.global.url_copied_to_clipboard'));
    },
    onClipboardError: function onClipboardError() {
      this.$notify.error(this.$t('notifications.global.url_copied_to_clipboard_failure'));
    },
    getIcon: function getIcon(meta) {
      var gender = meta === null || meta === void 0 ? void 0 : meta.gender;
      if (!gender) {
        return 'genderless';
      }
      return GenderEnum.icon(gender);
    },
    handleFetchResources: function handleFetchResources() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.$refs.datatable.fetchResources();
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    onUpdated: function onUpdated() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this3.handleFetchResources();
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getRegistrationUrl: function getRegistrationUrl(token) {
      var route = this.$router.resolve({
        name: this.$RouteEnum.REGISTER_EMPLOYEE,
        query: {
          token: token
        }
      });
      return "".concat(window.location.origin).concat(route.href);
    },
    resend: function resend(id) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return new Invitation({
                id: id
              }).resend();
            case 3:
              _context3.next = 5;
              return _this4.$notify.success(_this4.$t('notifications.notification.sent'));
            case 5:
              _context3.next = 10;
              break;
            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](0);
              _this4.$axios.handleError(_context3.t0);
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 7]]);
      }))();
    },
    destroy: function destroy(id) {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return new Invitation({
                id: id
              }).delete();
            case 3:
              _context4.next = 5;
              return _this5.$notify.success(_this5.$t('notifications.invitation.deleted'));
            case 5:
              _context4.next = 7;
              return _this5.handleFetchResources();
            case 7:
              _context4.next = 12;
              break;
            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](0);
              _this5.$axios.handleError(_context4.t0);
            case 12:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 9]]);
      }))();
    }
  }
});